import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';
const Tab1 = ({ purchasename, vendor, required_date, selectedAddress, podate, ponumber,activityboll,setasn_inclusion,asn_inclusion,ApiData }) => {
  const status = "Draft1"
  const [showActivity, setShowActivity] = useState(true);
  return (
    <div
      className="row sidebarbox m-0 d-flex flex-column"
      style={{
        padding: "8px", borderRadius: "5px", maxHeight: "68vh",
        overflowY: "scroll",flexWrap:'nowrap'
      }}
    >
      <div className="col-12">
        <div className="row">
<div className="col-md-6 mt-1 mb-2" >
        <Input id="orderNo" label="No." readOnly value={purchasename} style={{ height: '30px' }} />
      </div>
      <div className="col-md-6 mt-1">
        <Input id="orderdatepo" type="date" style={{ height: '30px' }} readOnly label="Order Date" value={podate.podate} onChange={(e) => podate.setpodate(e.target.value)} />
      </div>
        </div>
      </div>
      
      <div className="col-12 ">
        <div className={vendor.Error ? `mb-3 ` : `mb-3`}>
          <Input id="orderNo" label="Select Supplier" readOnly value={vendor.select_vendor} style={{ height: '30px' }} />
        </div>
      </div>
      <div className="col-12">
        <div className="mb-3">
          <Textarea
            id="ponumber"
            label="Supplier Address"
            value={
              selectedAddress.currentAddress?.name
                ? `${selectedAddress.currentAddress?.address_line1}, ${selectedAddress.currentAddress?.address_line2}, ${selectedAddress.currentAddress?.city}, ${selectedAddress.currentAddress?.state}\n${selectedAddress.currentAddress?.country} - ${selectedAddress.currentAddress?.pincode}`
                : ''
            }
            readOnly={status !== 'Draft'}
            style={{ whiteSpace: 'pre-wrap', border: selectedAddress.Error ? '1px solid red' : '', backgroundColor: '#f8f6f6' }}
          />
        </div>


      </div>
      <div className="col-12 ">
        <div className="mb-3 " >
          <Input id="termsandconditions" style={{ height: '30px' }} label="Required By" readOnly
            value={required_date.required_date}
            onChange={(e) => required_date.setrequired_date(e.target.value)} />
        </div>
      </div>
     <div style={{ display: 'flex', alignItems: 'center' }}>
  <input
    type="checkbox"
    id="asnInclusion"
    checked={asn_inclusion}
    style={{ accentColor: asn_inclusion ? '#270B79' : '#ccc' }} 
  />
  <label htmlFor="asnInclusion" style={{ marginLeft: '5px', fontSize: '0.85rem' }}>
    ASN Inclusion
  </label>
</div>

      <CollapsibleSection title="Accounting Dimensions">
          <div className="col-lg-12 mt-3 mb-3" >
        <Input id="termsandconditions" label="Cost Center" value={ApiData.message?.cost_center} readOnly style={{ height: '30px' }} />

          </div>
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={`mb-3`}>
            

        <Input id="termsandconditions" label="Project" value={ApiData.message?.project} readOnly style={{ height: '30px' }} />

            </div>
          </div>
        </CollapsibleSection>
  
        <CollapsibleSection title="Currency and Price List">
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={`mb-3`}>
        <Input id="termsandconditions" label="Currency" readOnly value={ApiData.message?.currency} style={{ height: '30px' }} />

           </div>
          </div>
  
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={`mb-3`}>
        <Input id="termsandconditions" label="Price List" value={ApiData.message?.buying_price_list} readOnly style={{ height: '30px' }} />

          </div>
          </div>
        </CollapsibleSection>
  
        <CollapsibleSection title="Taxes and Charges">
            <div className="col-lg-12 mt-3 mb-3" >
            <div className={`mb-3`}>
        <Input id="termsandconditions" label="Taxes and Charges" value={ApiData.message?.tax_category} readOnly style={{ height: '30px' }} />

          </div>
          </div>
        </CollapsibleSection>
  
        <CollapsibleSection title="Payment Terms">
          <div className="col-lg-12 mt-3 mb-3" >
            <div className={`mb-3`}>
        <Input id="termsandconditions" label="Payment Terms Template" value={ApiData.message?.payment_terms_template} readOnly style={{ height: '30px' }} />

          </div>
          </div>
          
        </CollapsibleSection>
       
        <CollapsibleSection title="Terms & Conditions">
     
          <div className="col-lg-12 mt-1 mb-3" >
             <div className={`mb-3`}>
        <Input id="termsandconditions" label="Terms and Conditions" value={ApiData.message?.tc_name} readOnly style={{ height: '30px' }} />

          </div>
          </div>
  
        </CollapsibleSection>






      <div >

        <div className="col-12">
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
            <p className="firstcolor m-0" >
              Activity
            </p>
            <GetIcon
              iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
              size={22}
            />
          </div>
          {showActivity && (
            <VersionHistory doctype="Purchase Order" docname={purchasename} activityboll={activityboll} />

          )}
        </div>
      </div>

    </div>
  )
}

export default Tab1